import axios from "axios";
import { ToastApi as toast } from "./components/UI/Toast/Toast";
import { AuthErrorApi } from "./components/UI/AuthError/AuthError";

axios.defaults.baseURL = process.env.WINSERVER_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Cache-Control"] = "no-cache";
axios.defaults.headers.common["x-access-token"] = sessionStorage.getItem("token");
axios.defaults.headers.common["Access-Control-Allow-Methods"] = "DELETE, GET, POST, PUT, OPTIONS";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = process.env.WINSERVER_URL;
axios.defaults.headers.common["Access-Control-Allow-Credentials"] = true;

const isTruthy = (val) => val && val !== "null";

axios.interceptors.request.use(function (config) {
	let winServerUrl = sessionStorage.getItem("winServerUrl");
	let hosted = sessionStorage.getItem("hosted");
	let access_token = localStorage.getItem("access_token");
	let sessionToken = sessionStorage.getItem("sessionToken");

	if (isTruthy(hosted) && isTruthy(access_token)) {
		config.baseURL = winServerUrl;
		config.headers = {
			Authorization: "Bearer " + access_token,
			sessionToken: sessionToken,
		};
	} else {
		config.headers = {
			sessionToken: sessionToken,
		};
	}
	let txnID = null;
	txnID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + "-" + Date.now();
	if (process.env.SPLUNK_ON === "enabled") {
		console.info(
			"[txnmarker=TXNStart]",
			"[txnID=" + txnID + "]",
			"[reqPath=" + process.env.WINSERVER_URL + config.url + "]",
			"[reqBody" + JSON.stringify(config.data) + "]"
		);
	}
	config.headers.txnid = txnID;
	return config;
});

axios.interceptors.response.use(
	function (response) {
		if (process.env.SPLUNK_ON === "enabled") {
			console.info(
				"[txnmarker=TXNEnd]",
				"[txnID=" + response.config.headers.txnid + "]",
				"[response" + JSON.stringify(response) + "]"
			);
		}

		// Do something with response data
		if (response.data.message === "Invalid Session Token" || response.status === 401 || response.status === "401") {
			// window.alert("Your session is invalid. Please try again from Agent OS.");
		}

		return response;
	},
	function (error) {
		// Do something with response error
		// 	function (error) {
		// Do something with response error

		// if (error?.response?.status === 404) {
		//   toast.show();
		// }
		if (error?.response?.status === 401) {
			AuthErrorApi.show();
		}
		return Promise.reject(error);
	}
);

export default axios;
